import React from 'react'
import { Link } from 'react-router-dom'
import RightHandSide from "../Common/Services/RightHandSide"
import Transition from '../Transition'

const Blog = () => {
  return (
    <>
    <div className="blog-area pt-100 pb-70">
        <div className="container">
            <div className="row">
                <div className="col-lg-8">
                    <div className="row">
                        {data.map((d, i) => (
                            <div key={i} className="col-lg-6 col-md-6 col-sm-6">
                                <div className="blog-card">
                                    <Link to={d.blogLink}><img src={d.BlogImg} className='rounded' alt="image1" /></Link>
                                    <Link to={d.careLink} className="care">{d.care}</Link>
                                    <h4>
                                        <Link to={d.blogLink}>{d.BlogHeading}</Link>
                                    </h4>
                                    <ul>
                                        <li className='first'>By <Link to="/Doctor">Admin</Link></li>
                                        <li className='second'>{d.date}</li>
                                    </ul>
                                </div>
                            </div>
                        ))}
                        
                        
                    </div>
                    
                </div>
                <div className="col-lg-4">
                    <RightHandSide />
                </div>
            </div>
        </div>
    </div>
    
    
    </>
  )
}

export default Transition(Blog) 

const data = [
      {
        BlogImg: require("../../Assets/images/blog/headDesign/36.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/36/10-Essential-Low-Sperm-Count-Signs",
        BlogHeading: "10 Essential Low Sperm Count Signs: Causes, Diagnosis & IVF Options in Mumbai",
        date: ""
    },
    {
        BlogImg: require("../../Assets/images/blog/headDesign/35.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/35/Does-Health-Insurance-Cover-IVF-in-India?",
        BlogHeading: "Does Health Insurance Cover IVF in India? (2026 Guide)",
        date: ""
    },
      {
        BlogImg: require("../../Assets/images/blog/headDesign/34.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/34/5-Smart-Insights-on-IUI-Cost-vs-IVF-Cost",
        BlogHeading: "5 Smart Insights on IUI Cost vs IVF Cost: Which Fits Your Budget?",
        date: ""
    },
    {
        BlogImg: require("../../Assets/images/blog/headDesign/33.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/33/7-Crucial-Facts-About-IVF-Cost-in-Mumbai-and-Chembur",
        BlogHeading: "7 Crucial Facts About IVF Cost in Mumbai and Chembur for 2026 Success",
        date: ""
    },
      {
        BlogImg: require("../../Assets/images/blog/headDesign/32.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/32/Best-Infertility-Specialist-in-Mumbai-Dr-Neelam-Bhise",
        BlogHeading: "Dr. Neelam Bhise Is the Best Infertility Specialist in Mumbai for IVF Success in 2026",
        date: ""
    },
    {
        BlogImg: require("../../Assets/images/blog/headDesign/31.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/31/Facts About Fertility Clinic Near Me: IVF, IUI, ICSI & Other Treatment Options Explained (2026)",
        BlogHeading: "Facts About Fertility Clinic Near Me: IVF, IUI, ICSI & Other Treatment Options Explained (2026)",
        date: ""
    },
    {
        BlogImg: require("../../Assets/images/blog/headDesign/30.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/30/Best Fertility Clinic in Mumbai | Trusted IVF Center 2026",
        BlogHeading: "Best Fertility Clinic in Mumbai | Trusted IVF Center 2026",
        date: ""
    },
    {
        BlogImg: require("../../Assets/images/blog/headDesign/29.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/29/Myths-and-Facts-About-Infertility-Treatment-(2026 Guide)",
        BlogHeading: "Myths and Facts About Infertility Treatment (2026 Guide)",
        date: ""
    },
    {
        BlogImg: require("../../Assets/images/blog/headDesign/28.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/28/IVF-Success-Rates-in-India:Proven-2026-Guide",
        BlogHeading: "IVF Success Rates in India: What Couples Should Know in 2026",
        date: ""
    },
    {
        BlogImg: require("../../Assets/images/blog/headDesign/27.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/27/Gynecologist-Hospital-in-Chembur:-Expert-Women's-Healthcare-&-Fertility-Care",
        BlogHeading: "Gynecologist Hospital in Chembur: Expert Women's Healthcare & Fertility Care",
        date: ""
    },
    {
        BlogImg: require("../../Assets/images/blog/headDesign/26.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/26/7-Reasons-Acme-Fertility-Is-the-Top-IVF-Hospital-in-Mumbai-for-Higher-Success-Rates",
        BlogHeading: "7 Reasons Acme Fertility Is the Top IVF Hospital in Mumbai for Higher Success Rates (2026)",
        date: ""
    },
    {
        BlogImg: require("../../Assets/images/blog/headDesign/25.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/25/5-Powerful-Reasons-Why-Couples-Choose-IVF-for-Successful-Parenthood",
        BlogHeading: "5 Powerful Reasons Why Couples Choose IVF for Successful Parenthood",
        date: ""
    },
      {
        BlogImg: require("../../Assets/images/blog/headDesign/24.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/24/Best-IVF-Clinic-in-Mumbai-in-2026",
        BlogHeading: "Best IVF Clinic in Mumbai in 2026",
        date: ""
    },
      {
        BlogImg: require("../../Assets/images/blog/headDesign/23.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/23/Best-Infertility-Specialist-in-Mumbai",
        BlogHeading: "Best Infertility Specialist in Mumbai (2026 Guide)",
        date: ""
    },
    {
        BlogImg: require("../../Assets/images/blog/headDesign/22.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/22/7-proven-reasons-to-choose-fertility-clinic",
        BlogHeading: "7 Proven Reasons to Choose a Fertility Clinic and Hospital in Chembur for Successful Fertility Care in 2026",
        date: ""
    },
     {
        BlogImg: require("../../Assets/images/blog/headDesign/21.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/21/best-gynecologist-hospital-in-chembur",
        BlogHeading: "Best Gynecologist Hospital in Chembur for Safe Pregnancy",
        date: ""
    },
    {
        BlogImg: require("../../Assets/images/blog/headDesign/20.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/20/7-proven-reasons-acme-fertility",
        BlogHeading: "7 Proven Reasons Acme Fertility Is the Best Fertility Doctor in Mumbai in 2026",
        date: ""
    },
    {
        BlogImg: require("../../Assets/images/blog/headDesign/19.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/19/choose-an-ivf-center-in-mumbai",
        BlogHeading: "Why Choose an IVF Center in Mumbai for Parenthood Success (2026)",
        date: ""
    },
    {
        BlogImg: require("../../Assets/images/blog/headDesign/18.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/18/trusted-ivf-centre-in-mumbai",
        BlogHeading: "IVF Centre in Mumbai: Your Trusted Fertility Clinic",
        date: ""
    },
    {
        BlogImg: require("../../Assets/images/blog/headDesign/17.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/17/ivf-specialist-in-chembur-mumbai",
        BlogHeading: "Acme Fertility – Top IVF Specialist in Chembur",
        date: ""
    },
    {
        BlogImg: require("../../Assets/images/blog/headDesign/16.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/16/BlogDetails",
        BlogHeading: "Best IVF Centre in Chembur",
        date: ""
    },
    {
        BlogImg: require("../../Assets/images/blog/headDesign/1.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/1/BlogDetails",
        BlogHeading: "How to Prepare for Your First IVF Cycle: A Step-by-Step Guide",
        date: ""
    },
    {
        BlogImg: require("../../Assets/images/blog/headDesign/2.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/2/BlogDetails",
        BlogHeading: "The Role of Genetics in IVF: What You Should Know",
        date: ""
    },
    {
        BlogImg: require("../../Assets/images/blog/headDesign/3.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/3/BlogDetails",
        BlogHeading: "IVF and Age: When is the Best Time to Start?",
        date: ""
    },
    {
        BlogImg: require("../../Assets/images/blog/headDesign/4.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/4/BlogDetails",
        BlogHeading: "The Latest Innovations in IVF Technology for 2024",
        date: ""
    },
    {
        BlogImg: require("../../Assets/images/blog/headDesign/5.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/5/BlogDetails",
        BlogHeading: "Importance of Mental Health Support During IVF Treatments",
        date: ""
    },
    {
        BlogImg: require("../../Assets/images/blog/headDesign/6.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/6/BlogDetails",
        BlogHeading: "Egg Freezing vs. IVF: Which is the Better Option for You? ",
        date: ""
    },
    {
        BlogImg: require("../../Assets/images/blog/headDesign/7.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/7/BlogDetails",
        BlogHeading: "Unexpected Challenges in IVF: How to Navigate Secondary Infertility",
        date: ""
    },
    {
        BlogImg: require("../../Assets/images/blog/headDesign/8.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/8/BlogDetails",
        BlogHeading: "Natural Ways to Boost Fertility Before Considering IVF",
        date: ""
    },
    {
        BlogImg: require("../../Assets/images/blog/headDesign/9.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/9/BlogDetails",
        BlogHeading: "IVF Success Rates & Statistics: Understanding Your Chances ",
        date: ""
    },
    {
        BlogImg: require("../../Assets/images/blog/headDesign/10.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/10/BlogDetails",
        BlogHeading: "PCOS and Fertility Explained: Understanding the Connection",
        date: ""
    },
    {
        BlogImg: require("../../Assets/images/blog/headDesign/11.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/11/BlogDetails",
        BlogHeading: "What is a Frozen Embryo Transfer (FET)?",
        date: ""
    },
    {
        BlogImg: require("../../Assets/images/blog/headDesign/12.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/12/BlogDetails",
        BlogHeading: "Fresh vs Frozen Embryo Transfer: Which is Better?",
        date: ""
    },
    {
        BlogImg: require("../../Assets/images/blog/headDesign/13.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/13/BlogDetails",
        BlogHeading: "Understanding IVF Fertility: A Journey of Hope and Science",
        date: ""
    },
    {
        BlogImg: require("../../Assets/images/blog/headDesign/14.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/14/BlogDetails",
        BlogHeading: "IVF and Relationships: Supporting Each Other Through the Journey",
        date: ""
    },
    {
        BlogImg: require("../../Assets/images/blog/headDesign/15.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/15/BlogDetails",
        BlogHeading: "How Sleep and Mental Well-being Impact IVF Success",
        date: ""
    },
]